import { showErrorToast } from "app/actions/toast_actions";
import { translate } from "app/filters/i18nFilter";
import type { ThunkDependencies } from "single-spa/store/thunk-dependencies";
import type { ThunkDispatchCommon, ThunkGetState } from "single-spa/store/types";
import { managementActions } from "../../action-creators";
import { getHsExclusionStatusThunk } from "./exclude";
import { setHsCrmListObjectsType } from "../../actions/hubspotActions";
import type { CRMListObjectsType } from "../../../types";
import { selectHsListObjectsType } from "../../selectors/hubspotSelectors";

const getHsCompaniesStatusThunk =
    () => async (dispatch: ThunkDispatchCommon, _getState: ThunkGetState, deps: ThunkDependencies) => {
        try {
            dispatch(managementActions.hubspot.getCompaniesStatusAsync.request());
            const { value } = await deps.si.api.management.getCompaniesStatusHubspot();
            dispatch(managementActions.hubspot.getCompaniesStatusAsync.success(value));
        } catch (error) {
            dispatch(managementActions.hubspot.getCompaniesStatusAsync.failure(error));
        }
    };

export const putHsCompaniesToggleThunk =
    (status: boolean) => async (dispatch: ThunkDispatchCommon, _getState: ThunkGetState, deps: ThunkDependencies) => {
        try {
            dispatch(managementActions.hubspot.putCompaniesStatusAsync.request());
            const response = await deps.si.api.management.putHsCompaniesFilterStatus(status);

            dispatch(managementActions.hubspot.putCompaniesStatusAsync.success(response));
        } catch (error) {
            dispatch(managementActions.hubspot.putCompaniesStatusAsync.failure(error));
        }
    };

export const putHsContactsToggleThunk =
    (payload: boolean) => async (dispatch: ThunkDispatchCommon, _getState: ThunkGetState, deps: ThunkDependencies) => {
        try {
            dispatch(managementActions.hubspot.putContactsToggleAsync.request());

            const response = await deps.si.api.management.putHsContactsFilterStatus(payload);
            dispatch(managementActions.hubspot.putContactsToggleAsync.success(response));
            dispatch(getHsExclusionStatusThunk());
        } catch (error) {
            dispatch(managementActions.hubspot.putContactsToggleAsync.failure(error));
        }
    };

export const setIsHsCrmLabelEnabledThunk =
    (payload: boolean) => async (dispatch: ThunkDispatchCommon, _getState: ThunkGetState, deps: ThunkDependencies) => {
        try {
            dispatch(managementActions.hubspot.setIsHsCrmLabelEnabled(payload));
            await deps.si.api.management.setIsHsCrmLabelEnabled(payload);
        } catch (error) {
            dispatch(managementActions.hubspot.setIsHsCrmLabelEnabled(!payload));
            dispatch(showErrorToast(translate("si.crm-integration.update-is-crm-label-enabled.error")));
        }
    };

export const setIsHsCrmListEnabledThunk =
    (payload: boolean) => async (dispatch: ThunkDispatchCommon, _getState: ThunkGetState, deps: ThunkDependencies) => {
        try {
            dispatch(managementActions.hubspot.setIsHsCrmListEnabled(payload));
            await deps.si.api.management.setIsHsCrmListEnabled(payload);
        } catch (error) {
            dispatch(managementActions.hubspot.setIsHsCrmListEnabled(!payload));
            dispatch(showErrorToast(translate("si.crm-integration.update-is-crm-list-enabled.error")));
        }
    };

export const setHsCrmListObjectsTypeThunk =
    (objectsType: CRMListObjectsType) =>
    async (dispatch: ThunkDispatchCommon, getState: ThunkGetState, deps: ThunkDependencies) => {
        const prevObjectsType = selectHsListObjectsType(getState());
        try {
            dispatch(setHsCrmListObjectsType(objectsType));
            await deps.si.api.management.setHsCrmListObjectsType(objectsType);
        } catch (error) {
            dispatch(setHsCrmListObjectsType(prevObjectsType));
            dispatch(showErrorToast(translate("si.crm-integration.update-crm-list-objects-type.error")));
        }
    };
